<div class="insight-card">
  <mat-card-header>
    <h3 class="insight-title">{{ title }}</h3>
  </mat-card-header>
  <mat-card-content>
    <p class="insight-body">{{ body }}</p>
  </mat-card-content>
</div>
